<template>
  <v-container fluid>
    <tab-nav></tab-nav>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      active: null,
      breadcrumbs: [
        { text: 'Dashboard', disabled: true, href: '/dashboard' }
      ]
    }
  },
  mounted: function () {
    this.loadBreadcrumbs(this.breadcrumbs)
    this.loadCurNav(this.navMenu)
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      navMenu: 'nav/navMenu'
    })
  },
  methods: {
    ...mapActions({
      loadBreadcrumbs: 'nav/loadBreadcrumbs',
      loadCurNav: 'nav/loadCurNav'
    })
  }
}
</script>

<style scoped>

</style>
